import cls from "classnames";
import Button, {
  ButtonPrimary,
} from "@qoohoo/common/components/library/Button";

export default function NextButton({
  step,
  isLoading,
  handleNextButton,
  className,
  size,
}) {
  const label = step > 0 ? "Submit" : "Next";

  return (
    <ButtonPrimary
      className={cls("group !text-sm !w-[120px]", className)}
      size={size || Button.SIZE.small}
      onClick={handleNextButton}
      disabled={isLoading}
      isLoading={isLoading}
      doOpacityForDisabled
    >
      <div className="relative flex flex-row items-center justify-center gap-2">
        <span>{label}</span>
        <img
          src="/assets/icons/arrow-right.svg"
          alt="right arrow"
          className="w-4 h-4 group-hover:translate-x-1 transition-transform"
        />
      </div>
    </ButtonPrimary>
  );
}
